<template>
    <b-row no-gutters>
        <b-col :lg="8">
            <link
                rel="stylesheet"
                href="https://unpkg.com/leaflet@1.3.4/dist/leaflet.css"
                integrity="sha512-puBpdR0798OZvTTbP4A8Ix/l+A4dHDD0DGqYW6RQ+9jxkRFclaxxQb/SJAWZfWAkuyeQUytO7+7N4QKrDh+drA=="
                crossorigin=""
            />
            <StoresMap :searchedPosition="position" class="bg-white" />
        </b-col>
        <b-col :lg="4">
            <StoresList :class="listClasses" />
        </b-col>
    </b-row>
</template>

<script>

    import StoresMap from './StoresMap.vue'
    import StoresList from './StoresList.vue'

    export default {
        name : 'StoresDisplay',

        props : {
            listMargins: {
                type : Boolean,
                required : false,
                default : false,
            },
        },

        components : {
            StoresMap,
            StoresList,
        },

        store : {
            stores: 'stores',
        },

        data() {
            return {
                loading : true,
                position : null,
                address : "",
            }
        },

        computed : {
            listClasses() {
                return {
                    'mt-3' : true,
                    'mb-3' : this.listMargins,
                    'mr-3' : this.listMargins,
                    'ml-0' : true,
                    'ml-lg-3' : true,
                    'mt-lg-0' : !this.listMargins,
                    'bg-white' : true,
                }
            },
        },

        apollo : {
            geolocalizedStores: {
                query() {
                    return this.getQuery('GeolocalizedStores')
                },
                variables() {
                    return {
                        address : this.address
                    }
                },
                loadingKey : 'loading',
                fetchPolicy : 'cache-and-network',
                result({ data, loading, networkStatus }) {
                    if (data) {
                        this.stores = this.mapEdges(data.geolocalizedStores.stores);
                        if (data.geolocalizedStores.position) {
                            this.position = data.geolocalizedStores.position
                        }
                    }
                    this.loading = loading;
                },
            }
        },

        mounted() {
            this.$root.$on('search:address', (address) => {
                this.address = address
                this.$apollo.queries.geolocalizedStores.refetch()
            })
        },
    }
</script>
